/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Task_CancelledInputs */

const cs_enum_task_cancelled = /** @type {(inputs: Enum_Task_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol zrušen`)
};

const en_enum_task_cancelled = /** @type {(inputs: Enum_Task_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task cancelled`)
};

/**
* | output |
* | --- |
* | "Task cancelled" |
*
* @param {Enum_Task_CancelledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_task_cancelled = /** @type {((inputs?: Enum_Task_CancelledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Task_CancelledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_task_cancelled(inputs)
	return cs_enum_task_cancelled(inputs)
});